var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page-full page-cancelable"},[_c('b-tabs',{attrs:{"pills":"","lazy":""}},[_c('b-tab',{attrs:{"title":"Main","active":""}},[_c('report-main')],1),(_vm.isAdmin)?_c('b-tab',{attrs:{"title":"Final Report"}},[_c('report-final-report')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }